"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
/**
 * Renders an image picker component, which pass to parent the imported img. Renders the picker and also the current selected img.
 * @param setUploadImage Set state function which pass up the File imported object in order to trigger the corresponding mutation.
 * @param prevImage A string containing the URL reference to the prev img (before being set it up by the picker).
 * @param style Optional extra styles to add to the components main container.
 */
function ImagePicker(_a) {
    var setUploadImage = _a.setUploadImage, prevImage = _a.prevImage, options = _a.options, style = _a.style, name = _a.name, id = _a.id, errorMessage = _a.errorMessage, onDropRejected = _a.onDropRejected;
    var _b = react_1.useState(undefined), selectedImage = _b[0], setSelectedImage = _b[1];
    var onDrop = react_1.useCallback(function (_a) {
        var file = _a[0];
        if (file) {
            setUploadImage(file);
            setSelectedImage(Object.assign(file, {
                preview: URL.createObjectURL(file),
            }));
        }
    }, [setUploadImage]);
    var _c = react_dropzone_1.useDropzone(__assign(__assign({ onDrop: onDrop,
        onDropRejected: function (event) {
            onDropRejected && onDropRejected(event);
        } }, options), { accept: "image/*", multiple: false })), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive;
    react_1.useEffect(function () { return function () {
        if (selectedImage)
            URL.revokeObjectURL(selectedImage.preview);
    }; }, [selectedImage]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.MainContainer, __assign({}, getRootProps(), { backgroundImage: (selectedImage && selectedImage.preview) || prevImage || "", style: style }),
            react_1.default.createElement("input", __assign({ name: name, id: id }, getInputProps())),
            isDragActive ? (react_1.default.createElement("p", null, "Suelta aqu\u00ED tu imagen...")) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.SelectContainer, null,
                    react_1.default.createElement(styles_1.Paragraph, null, "Seleccionar"))))),
        errorMessage && (react_1.default.createElement("p", { style: { color: theme_1.default.colorsPalette.red.default, marginLeft: 10 } }, errorMessage))));
}
exports.default = ImagePicker;
//# sourceMappingURL=index.js.map